module.exports = __webpack_public_path__ + "img/woman.f2d572fc.png";